import { v4 as uuidv4 } from 'uuid';

const EBAY_CONSENT_STATE_STORAGE_KEY = 'flox.ebayConsentState';

function withSessionStorageUnlessBlocked<T>(
  operation: (storage: Storage) => T,
  resultWhenBlocked: T
): T {
  try {
    return operation(window.sessionStorage);
  } catch {
    return resultWhenBlocked;
  }
}

export function createEbayConsentState(): string {
  return uuidv4();
}

export function rememberEbayConsentState(state: string): void {
  withSessionStorageUnlessBlocked(
    (storage) => storage.setItem(EBAY_CONSENT_STATE_STORAGE_KEY, state),
    undefined
  );
}

export function readEbayConsentState(): string | null {
  return withSessionStorageUnlessBlocked(
    (storage) => storage.getItem(EBAY_CONSENT_STATE_STORAGE_KEY),
    null
  );
}

export function forgetEbayConsentState(): void {
  withSessionStorageUnlessBlocked(
    (storage) => storage.removeItem(EBAY_CONSENT_STATE_STORAGE_KEY),
    undefined
  );
}
